export default {
    namespaced: true,
    state: () => ({
        store: {
            brand_id: null,
            store_id: null,
            store_name: null,
            zip_code: null,
            address: null,
            remarks: null,
            phone_number: null,
            admin_name: null,
        },
        selectedStoreId: null
    }),
    getters: {
        data(state) {
            return state.store
        },
        id (state) {
            return state.store.store_id
        },
        name (state) {
            return state.store.store_name
        },
        brandId(state) {
            return state.store.brand_id
        },
        adminName (state) {
            return state.store.admin_name
        },
        selectedStoreId (state) {
            return state.selectedStoreId
        }
    },
    mutations: {
        setStore(state, payload) {
            state.store = payload
        },
        setStoreId(state, payload) {
            state.selectedStoreId = payload
        }
    },
    actions: {
        async fetchStore({ commit }, {axios, endpoint, brandId, storeId}) {
            const res = await axios.get(endpoint + 'manage/brand/' + brandId + '/store/' + storeId)
            let store = { store_id: storeId }
            store.brand_id = res.data.brandId
            const data = res.data.storeData
            store.store_name = data.storeName
            store.zip_code = data.zipCode
            store.address = data.address
            store.remarks = data.remarks
            store.phone_number = data.phoneNumber
            store.admin_name = data.adminName
            commit('setStore', store)
        },
        doUpdate({ commit }, {data, brandId}) {
            let store = { store_id: data.storeId }
            store.brand_id = brandId
            store.address = data.address
            store.admin_name = data.adminName
            store.phone_number = data.phoneNumber
            store.remarks = data.remarks
            store.store_id = data.storeId
            store.store_name = data.storeName
            store.zip_code = data.zipCode
            commit('setStore', store)
        },
        doClear({ commit }) {
            const store = {
                brand_id: null,
                store_id: null,
                store_name: null,
                zip_code: null,
                address: null,
                remarks: null,
                phone_number: null,
                admin_name: null,
            }
            commit('setStore', store)
        },
        setStoreId({ commit }, selectedStoreId) {
            commit('setStoreId', selectedStoreId )
        },
        doUpdateId({ commit }, {data, storeId, storeName, adminName}) {
            let store = { store_id: data.storeId }
            store.brand_id = data.brandId
            store.address = data.address
            store.admin_name = adminName
            store.phone_number = data.phoneNumber
            store.remarks = data.remarks
            store.store_id = storeId
            store.store_name = storeName
            store.zip_code = data.zipCode
            commit('setStore', store)
        },
    },
}
